import { render, staticRenderFns } from "./EvaluateRecords.vue?vue&type=template&id=16c5ef2c&scoped=true"
import script from "./EvaluateRecords.vue?vue&type=script&lang=js"
export * from "./EvaluateRecords.vue?vue&type=script&lang=js"
import style0 from "./EvaluateRecords.vue?vue&type=style&index=0&id=16c5ef2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5ef2c",
  null
  
)

export default component.exports